import { render, staticRenderFns } from "./ContentBlockCustom.vue?vue&type=template&id=aec61968"
import script from "./ContentBlockCustom.vue?vue&type=script&lang=js"
export * from "./ContentBlockCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports